import { render, staticRenderFns } from "./ScriptTermLife.vue?vue&type=template&id=71f31c54&"
import script from "./ScriptTermLife.vue?vue&type=script&lang=js&"
export * from "./ScriptTermLife.vue?vue&type=script&lang=js&"
import style0 from "./ScriptTermLife.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports